import { render, staticRenderFns } from "./NotificationsBar.vue?vue&type=template&id=6e734c90&scoped=true"
import script from "./NotificationsBar.vue?vue&type=script&lang=js"
export * from "./NotificationsBar.vue?vue&type=script&lang=js"
import style0 from "./NotificationsBar.vue?vue&type=style&index=0&id=6e734c90&prod&scoped=true&lang=css"
import style1 from "./NotificationsBar.vue?vue&type=style&index=1&id=6e734c90&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e734c90",
  null
  
)

export default component.exports